// extracted by mini-css-extract-plugin
export default {"titleBox":"styles_titleBox__od1Ng","titleCursor":"styles_titleCursor__R5uj9","title":"styles_title__vqijf"};